import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Sirve para cualquier marca de scooter?',
    a: 'Sí. Los eBooks están diseñados como guías universales. Aplican a Xiaomi, Ninebot, Kugoo, Kaabo, y prácticamente cualquier scooter eléctrico del mercado argentino. Hay secciones específicas para modelos de 36–48V y para alta potencia 60–72V.'
  }, {
    q: '¿Necesito conocimientos técnicos previos?',
    a: 'No. Está escrito para el usuario final, en lenguaje claro y sin tecnicismos innecesarios. Si hay un término técnico, está explicado en el mismo momento.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Acceso inmediato después del pago. Descargás los PDFs en menos de 5 minutos desde cualquier dispositivo.'
  }, {
    q: '¿Qué lo diferencia de los videos de YouTube?',
    a: 'Los videos de YouTube suelen ser en inglés, para modelos que no se consiguen en Argentina, sin estructura, sin checklist y sin poder pausar y volver al punto exacto. Estos eBooks están escritos para Argentina, en español, con tablas, checklists imprimibles y un método paso a paso que podés seguir con el scooter adelante.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-surface/30" data-id="element-85">
      <div className="max-w-3xl mx-auto" data-id="element-86">
        <div className="text-center mb-12" data-id="element-87">
          <h2 className="text-3xl font-heading font-bold text-white" data-id="element-88">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, idx) => <div key={idx} className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-90">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-91">
                <span className="font-bold text-lg text-white" data-id="element-92">{faq.q}</span>
                <ChevronDown className={`text-brand transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={24} data-id="element-93" />
              </button>
              <AnimatePresence data-id="element-94">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-95">
                    <div className="px-6 pb-6 text-gray-300 border-t border-border/50 pt-4" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}